import React from 'react'
import { endOfMonth } from 'date-fns'
import { useQuery } from '@tanstack/react-query'
import { SpinnerWrapper } from '../../../common/SpinnerWrapper'
import { FacilityBookingListItem } from '../FacilityBookingListItem'
import { ErrorView } from '../../../../views/error/ErrorView'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { IllustrationChoices } from '../../../common/Illustration'
import { IFacilityModel } from '../../../../interfaces/models/facilities.interfaces'
import { bookingQueries } from '../../../../api/bookings'

interface FacilityBookingsListProps {
  facility: IFacilityModel
  startOfMonthDate: Date
}

export const FacilityBookingsList = ({
  facility,
  startOfMonthDate,
}: FacilityBookingsListProps): React.ReactNode => {
  const { translate } = useAppTranslation()

  const { data: bookingsData, isLoading: isLoadingBookings } = useQuery(
    bookingQueries.getBookingsPerFacility(
      facility._id,
      startOfMonthDate,

      new Date(
        endOfMonth(startOfMonthDate).getTime() -
          new Date().getTimezoneOffset() * 60 * 1000
      )
    )
  )

  const bookings = bookingsData?.reverse()

  const loading = isLoadingBookings

  if (loading) {
    return <SpinnerWrapper />
  }

  if (bookings && bookings.length === 0) {
    return (
      <ErrorView
        title={translate('facilityView.bookings.errorView.noBookings.title')}
        subtitle={translate(
          'facilityView.bookings.errorView.noBookings.subtitle'
        )}
        illustration={IllustrationChoices.CHECKLIST}
        titleWrapperClassName="mt-10"
        className="pt-32"
      />
    )
  }

  return (
    <>
      {bookings?.map((_booking) => (
        <FacilityBookingListItem
          key={_booking._id}
          booking={_booking}
          facility={facility}
        />
      ))}
    </>
  )
}
